import { useEffect, type Dispatch, type SetStateAction } from "react";

export const useSyncWithQRPreview = (
  withQR: boolean | undefined,
  setWithQRForPreview: Dispatch<SetStateAction<boolean>>,
) => {
  useEffect(() => {
    setWithQRForPreview(withQR ?? true);
  }, [withQR, setWithQRForPreview]);
};
